import { FlaskConical } from "lucide-react";
import { Pill } from "@/components/Badges";
import { money } from "@/lib/api";

export function ReconInfo({ it }) {
  if (!it.reconstitute) return null;
  return (
    <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
      <FlaskConical className="h-3.5 w-3.5 text-emerald-400" />
      <span className="font-mono-data">{it.bac_ml} mL BAC/vial ({it.bac_option})</span>
      <span className="font-mono-data">+{money(it.recon_fee)}</span>
      <Pill color={it.recon_status === "done" ? "emerald" : "amber"}>{it.recon_status === "done" ? "Reconstituted" : "Awaiting reconstitution"}</Pill>
    </div>
  );
}

export function OrderItemRow({ it, action }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3 border-b border-border/60 py-3 last:border-0">
      <div>
        <p className="text-sm font-medium">
          {it.name} <span className="font-mono-data text-muted-foreground">{it.vial_size} × {it.quantity}</span>
          {it.was_on_sale && <span className="ml-2 font-mono-data text-xs text-orange-400">sale</span>}
        </p>
        <ReconInfo it={it} />
      </div>
      <div className="flex items-center gap-3">
        {action}
        <span className="font-mono-data text-sm">{money(it.line_total)}</span>
      </div>
    </div>
  );
}
